// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab--2W8ckbdp2h","selected":"selected--1rDuppsoTN"};